import { CheckboxField, SelectField } from '@brighte/form-components';
import { FINANCIAL_PRODUCT, SummaryType, summarySchema } from '@brighte/validation';
import { StepNavigator } from '@components/StepNavigator';
import { ApplicationFormStatus } from '@graphql/generated/graphql';
import { useApplicationData } from '@provider';
import { Text } from '@spark-web/text';
import { APPLICATION_STEPS, SUMMARY, getFormFields, isFieldExists } from '@utils';
import { SignatorySection } from './SignatorySection';

function Summary() {
  const { TITLE, DESCRIPTION, CONFIRMATION, SOURCE_OF_FUNDS, SOURCE_DESCRIPTION, SOURCE_OF_FUNDS_OPTIONS } = SUMMARY;

  const quote = useApplicationData('quote');
  const financialProductId = quote?.financialProduct.id ?? '';
  return (
    <StepNavigator<SummaryType>
      schema={summarySchema}
      name={APPLICATION_STEPS.SUMMARY}
      title={TITLE}
      defaultValues={{}}
      continueLabel="Submit"
    >
      {({ register, control, setValue }) => {
        const additionalFields = getFormFields(summarySchema, financialProductId);
        const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          setValue('applicant.termsAndConditions.capacityToPay', event.target.value);
        };

        const financedAmount = quote?.financedAmount ?? 0;

        return (
          <>
            {(financialProductId === FINANCIAL_PRODUCT.SME ||
              financialProductId === FINANCIAL_PRODUCT.ACT_COMMUNITY) && <SignatorySection />}
            <Text>{DESCRIPTION}</Text>
            {isFieldExists(additionalFields, 'applicant.termsAndConditions.capacityToPay') ? (
              <CheckboxField
                name="applicant.termsAndConditions.capacityToPay"
                control={control}
                onChange={event => handleOnChange(event)}
              >
                <Text>{CONFIRMATION(financedAmount)}</Text>
              </CheckboxField>
            ) : null}
            {isFieldExists(additionalFields, 'payment.source') ? (
              <SelectField
                name="payment.source"
                control={control}
                label={SOURCE_OF_FUNDS}
                fieldProps={{
                  description: SOURCE_DESCRIPTION(financedAmount),
                }}
                options={SOURCE_OF_FUNDS_OPTIONS}
                placeholder="Select"
              />
            ) : null}
            <input type="hidden" {...register('status')} value={ApplicationFormStatus.Submitted} />
            <input type="hidden" {...register('financialProductId')} value={financialProductId} />
          </>
        );
      }}
    </StepNavigator>
  );
}

export default Summary;
